exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@special-offer : ~'.special-offer';\n.special-offer__link[data-v-3a710b13]:after {\n  -webkit-transition: all 0.2s ease-in-out;\n  -o-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  display: inline-block;\n  background-color: #000000;\n  left: 0;\n  position: absolute;\n  width: 100%;\n  content: '';\n  bottom: 1px;\n  height: 1px;\n}\n.special-offer__link[data-v-3a710b13]:hover:after {\n  opacity: 0;\n}\n.special-offer--even .special-offer__left[data-v-3a710b13] {\n  background-color: #ffffff;\n}\n.special-offer--odd .special-offer__left[data-v-3a710b13] {\n  background-color: #f2f2f2;\n}\n", ""]);

// exports
